import { Cross2Icon } from '@radix-ui/react-icons'
import { Dialog, Flex, IconButton } from '@radix-ui/themes'
import { ReactNode } from 'react'

export type ModalProps = {
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  children: ReactNode
  hideCloseButton?: boolean
  hideTitle?: boolean
  className?: string
}

export const Modal = ({
  onOpenChange,
  title,
  description,
  children,
  hideCloseButton,
  hideTitle,
  className,
}: ModalProps) => {
  return (
    <Dialog.Root defaultOpen={true} onOpenChange={onOpenChange}>
      <Dialog.Content className={className}>
        <Dialog.Description hidden>{description}</Dialog.Description>

        {hideCloseButton ? null : (
          <Flex gap="3" justify="end">
            <Dialog.Close>
              <IconButton variant="ghost" aria-label="Close">
                <Cross2Icon height="20" width="20" style={{ color: 'black' }} />
              </IconButton>
            </Dialog.Close>
          </Flex>
        )}

        <Dialog.Title hidden={hideTitle === undefined ? true : hideTitle}>{title}</Dialog.Title>

        {children}
      </Dialog.Content>
    </Dialog.Root>
  )
}
